import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { getConsolidatedData, getDeviceStatusData } from "../../../services/dashboardService";
import AlertTemplateMessage from "../../Configuration/AlertTemplate/AlertTemplateMessage";
import { DASHBOARD_INTERVAL_TIMER } from "../../../config";

const initialCardData = {
  ClientId: null,
  ClientName: "",
  Site: 0,
  Operators: {},
  Devices: {},
};

const getcsvFileName = (param1, param2) => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');
  const csvFileName = `${param1.toLowerCase()}_${param2.toLowerCase()}_data_${yyyy}-${mm}-${dd}`;
  return csvFileName;
};

const MainOrg = ({ clientName, setSelectedTab, handleModalShow }) => {
  const [cardDataList, setCardDataList] = useState([]);
  const [consolidatedData, setConsolidatedData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loggedInUser, setLoggedInUser] = useState(null);

  useEffect(() => {
    setSelectedTab && setSelectedTab("dashboard");
    let tempUser = JSON.parse(localStorage.getItem("user"));
    setLoggedInUser(tempUser);
  }, [setSelectedTab]);

  const user = JSON.parse(localStorage.getItem("user"));
  const UserID = user?.Id;

  // Fetch consolidated data and set as array of cardData
  const fetchConsolidatedData = (globalFilter = {}) => {
    getConsolidatedData({
      UserID: UserID,
      widgets: [
        {
          WidgetID: 101,
          WidgetType: "GroupBy",
          Datapoints: ["ClientId", "ClientName"],
        },
      ],
      filters: globalFilter,
    })
      .then((res) => {
        if (
          res &&
          res.Status === "success" &&
          Array.isArray(res.Data) &&
          res.Data[0]?.WidgetData
        ) {
          const widgetData = res.Data[0].WidgetData;

          // Find operator info (row with null ClientId)
          const operatorRow = widgetData.find(
            (row) => row.ClientId === null && row.ClientName === null
          );
          const operators = operatorRow
            ? {
                LoggedInUser: operatorRow.Entity?.LoggedInUser || 0,
                TotalUser: operatorRow.Entity?.TotalUser || 0,
                LoggedOutUser: (operatorRow.Entity?.TotalUser || 0) - (operatorRow.Entity?.LoggedInUser || 0)
              }
            : {};

          // Filter out operator row for cards
          const baseCardDataList = widgetData
            .filter((row) => row.ClientId !== null)
            .map((row) => ({
              ClientId: row.ClientId ?? null,
              ClientName: row.ClientName ?? "",
              Customer: row.Entity?.Customer ?? 0,
              Site: row.Entity?.Site ?? 0,
              Operators: operators, // Attach operator info to each card
              Devices: {}, // Will be filled after device data fetch
            }));

          // Fetch device status data and merge
          getDeviceStatusData({
            UserID: UserID,
            widgets: [
              {
                WidgetID: 101,
                WidgetType: "GroupBy",
                Datapoints: ["ClientId", "ClientName"],
              }
            ],
            filters: globalFilter
          }).then((deviceRes) => {
            if (
              deviceRes &&
              deviceRes.Status === "success" &&
              Array.isArray(deviceRes.Data) &&
              deviceRes.Data[0]?.WidgetData
            ) {
              const deviceWidgetData = deviceRes.Data[0].WidgetData;

              // Merge device data into cardDataList
              const mergedCardDataList = baseCardDataList.map(card => {
                const deviceRow = deviceWidgetData.find(
                  d => d.ClientId === card.ClientId
                );
                return {
                  ...card,
                  Devices: deviceRow && deviceRow.Data ? deviceRow.Data : {},
                };
              });

              setCardDataList(mergedCardDataList);
              setConsolidatedData(mergedCardDataList);
            } else {
              setCardDataList(baseCardDataList);
              setConsolidatedData(baseCardDataList);
            }
          }).catch(() => {
            setCardDataList(baseCardDataList);
            setConsolidatedData(baseCardDataList);
          });
        } else {
          setCardDataList([]);
          setConsolidatedData([]);
        }
      })
      .catch((err) => {
        setCardDataList([]);
        setConsolidatedData([]);
        console.log(err);
      });
  };

  useEffect(() => {
    fetchConsolidatedData({});
    // eslint-disable-next-line
  }, []);

  useEffect(()=>{
    const interval = setInterval(() => {
      fetchConsolidatedData({});
    }, DASHBOARD_INTERVAL_TIMER);

    return () => clearInterval(interval);
  }, [DASHBOARD_INTERVAL_TIMER])

  const orgName = JSON.parse(localStorage.getItem("user"))?.OrganizationName;
  const history = useHistory();

  const showSiteDetail = (clientName, ClientId) => {
    history.push({
      pathname: "/customer-details",
      state: { clientName, ClientId },
    });
  };

  // Filter cardDataList by client name
  const filteredCardDataList = cardDataList.filter((card) =>
    card.ClientName?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Flatten Devices for UI: [{ deviceType, statuses: [{ status, count }], Interfacetypename }]
  const flattenDevices = (devices) => {
    const deviceMap = new Map();
    
    Object.entries(devices || {}).forEach(([Interfacetypename, deviceTypes]) => {
      Object.entries(deviceTypes).forEach(([deviceType, statusObj]) => {
        const key = `${Interfacetypename}-${deviceType}`;
        
        if (!deviceMap.has(key)) {
          deviceMap.set(key, {
            deviceType,
            Interfacetypename,
            statuses: []
          });
        }
        
        // Add all statuses for this device type
        Object.entries(statusObj).forEach(([status, count]) => {
          deviceMap.get(key).statuses.push({ status, count });
        });
      });
    });
    
    return Array.from(deviceMap.values());
  };

  return (
    <>
      <div>
        <div className="NameHeading1 mt-3 ml-3">
          <p className="config-tool-head">Organization: {orgName}</p>
        </div>
        <div className="d-flex align-items-center mr-4 justify-content-end">
          <div className="HeaderSiteList siteSearchDiv">
            <input
              type="text"
              placeholder="Search customer here"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ padding: "8px", width: "100%", height: "40px" }}
            />
          </div>
        </div>
      </div>
      <div className="col-lg-12 mt-2 float-left OrgMaiDiv">
        <div className="dashboard-container">
          {filteredCardDataList.length > 0 ? (
            filteredCardDataList.map((card, index) => (
              <div key={index} className="card">
                <div
                  className="card-header"
                  onClick={() => showSiteDetail(card.ClientName, card.ClientId)}
                  style={{ cursor: "pointer" }}
                >
                  Customer: <span>{card.ClientName}</span>
                </div>
                <div className="card-content">
                  <div className="device-list">
                    <div className="info-box">
                      Sites
                      <br />
                      <span
                        style={{
                          cursor: handleModalShow ? "pointer" : "default",
                        }}
                        onClick={() => {
                          handleModalShow &&
                            handleModalShow(
                              { EntityType: "Site" },
                              "Master",
                              null,
                              { CustomerID: [card.ClientId] },
                              getcsvFileName("total", "site"),
                              "Sites"
                            );
                        }}
                      >
                        {card.Site}
                      </span>
                    </div>

                    <div className="device-card">
                      <div className="device-title">Operators</div>
                      <div className="device-status">
                        <span
                          className="online"
                          style={{
                            cursor: handleModalShow ? "pointer" : "default",
                          }}
                          onClick={() =>
                            handleModalShow &&
                            handleModalShow(
                              { EntityType: "LoggedInUser" },
                              "Master",
                              null,
                              { CustomerID: [card.ClientId] },
                              getcsvFileName("user", "LoggedIn"),
                              "Operators"
                            )
                          }
                        >
                          {card.Operators?.LoggedInUser || 0} Online
                        </span>
                        <span
                          className="offline"
                          style={{
                            cursor: handleModalShow ? "pointer" : "default",
                          }}
                          onClick={() =>
                            handleModalShow &&
                            handleModalShow(
                              { EntityType: "LoggedOut" },
                              "Master",
                              null,
                              { CustomerID: [card.ClientId] },
                              getcsvFileName("user", "LoggedOut"),
                              "Operators"
                            )
                          }
                        >
                          {card.Operators?.LoggedOutUser || 0} Offline
                        </span>
                      </div>
                    </div>

                    {/* Devices */}
                    {flattenDevices(card.Devices).map((dev, devIdx) => (
                      <div className="device-card" key={devIdx}>
                        <div className="device-title">{dev.deviceType}</div>
                        <div className="device-status">
                          {dev.statuses.map((statusItem, statusIdx) => (
                            <span
                              key={statusIdx}
                              className={
                                (statusItem.status === "Online" || statusItem.status === "Normal" ? "online" : statusItem.status === "Offline" || statusItem.status === "Faulty" ? "offline" : "")
                              }
                              style={{
                                cursor: handleModalShow ? "pointer" : "default",
                                color: statusItem.status === "Online" || statusItem.status === "Normal" ? "#28a745" : statusItem.status === "Offline" || statusItem.status === "Faulty" ? "#dc3545" : "#555",
                                marginRight: statusIdx < dev.statuses.length - 1 ? "12px" : "0"
                              }}
                              onClick={() =>
                                handleModalShow &&
                                handleModalShow(
                                  { 'DeviceStatus': statusItem.status,
                                    'StatusFor': dev.deviceType,
                                    'InterfaceTypeName': dev.Interfacetypename,
                                    'IntegrationStatus': dev.Interfacetypename === 'CCTV' ? 'Integrated' : null
                                   },
                                  "DeviceStatus",
                                  null,
                                  { CustomerID: [card.ClientId] },
                                  getcsvFileName(dev.deviceType, statusItem.status),
                                  dev.deviceType,
                                )
                              }
                            >
                              {statusItem.count} {statusItem.status}
                            </span>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))
          ) : (
            // <p>No customer found</p>
            <AlertTemplateMessage message="No customer found" />
          )}
        </div>
      </div>
    </>
  );
};

export default MainOrg;